export default "__VITE_ASSET__BBJcPtOb__"